import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import '@/assets/styles/fonts.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import '@/assets/styles/MultiSelectOverrides.css';

Vue.component('multiselect', Multiselect);
